var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "c-warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-521.000000, -661.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-warning",
    transform: "translate(521.000000, 661.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 C17.9441217,0 0,17.9441217 0,40 C0,62.0558783 17.9441217,80 40,80 C62.0558783,80 80,62.0558783 80,40 C80,17.9441217 62.0558783,0 40,0 Z",
    id: "Path",
    fill: "#EFD358"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(35.000000, 15.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,37.1428571 C6.18339286,37.1428571 7.14285714,36.0341429 7.14285714,34.6666667 L7.14285714,2.47619048 C7.14285714,1.10871429 6.18339286,0 5,0 C3.81660714,0 2.85714286,1.10871429 2.85714286,2.47619048 L2.85714286,34.6666667 C2.85714286,36.0341429 3.81660714,37.1428571 5,37.1428571 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5,
    cy: 49.2857143,
    r: 5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.f00ae5f43d5cbf1a63b35eaa7b7f248a.svg";
export { ForwardRef as ReactComponent };